import { AppServices } from "@singularsystems/neo-core";
import StaticDataCache from "./StaticDataCache";

export const StaticDataExportedTypes = {
    Services: {
        StaticDataCache: new AppServices.ServiceIdentifier<StaticDataCache>("StaticData.Services.StaticDataCache"),
    },
}